
import { Component, Vue } from 'vue-property-decorator';
import WealthOrdersView from '@/modules/wealth/views/WealthOrders/WealthOrdersView.vue';
import WealthOrdersLegacyView from '@/modules/wealth/views/WealthOrdersLegacy/WealthOrdersLegacyView.vue';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';

@Component({
  components: {
    WealthOrdersView,
    WealthOrdersLegacyView
  }
})
export default class WealthOrdersPage extends Vue {
  get isWealthOrdersListEnabled() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.WEALTH_ORDERS_LIST);
  }
}
